import Searcher from "./Searcher";

export default Searcher;
